<template>
  <div class="home flexBox" v-if="isAll">
    <van-nav-bar
      class="flexNone"
      :style="{ background: sessionStorage.colorCode }"
      :title="$t('Dishes.name')"
      left-arrow
      fixed
      @click-left="
        $router.push(
          '/Home/' + sessionStorage.storeId + '/book/' + sessionStorage.code
        )
      "
    >
    </van-nav-bar>
    <div class="shopTitle">
      <div style="display: flex; align-items: center;">
        <van-icon
          v-if="shopInfos.image.path"
          :name="shopInfos.image.path"
          size="50px"
        />
        <van-icon v-else name="./static/img/SHOPLOGO.png" size="50px" />
        <span>{{ shopInfos.name }}</span>
      </div>
    </div>
    <div class="contentWrapper">
      <div v-if="dishes" class="menuContent">
        <van-sidebar v-model="activeKey" @change="changeKey()">
          <div v-for="(dish, index) in dishes" :key="index">
            <van-sidebar-item
              v-if="dish.status"
              :title="dish.name"
              :style="
                activeKey == index
                  ? {
                      'background-color': sessionStorage.colorCode,
                      'border-color': sessionStorage.colorCode
                    }
                  : {}
              "
            ></van-sidebar-item>
          </div>
        </van-sidebar>
        <div class="dishContent">
          <!-- 有产品 -->
          <template v-if="actMenus.length > 0">
            <div
              v-for="(menu, index) in actMenus"
              class="dishItem"
              :key="menu.id"
            >
              <div
                @click.stop="
                  menu.category == 'm'
                    ? $router.push('/E_DishDetail/' + menu.id)
                    : $router.push('/E_PackageDetail/' + menu.id)
                "
              >
                <template v-if="menu.image">
                  <van-image class="noflex" :src="menu.image.path" />
                </template>
                <template v-else>
                  <van-image class="noflex" :src="sessionStorage.images" />
                </template>
              </div>
              <div
                class="itemInfo"
                @click.stop="
                  menu.category == 'm'
                    ? $router.push('/E_DishDetail/' + menu.id)
                    : $router.push('/E_PackageDetail/' + menu.id)
                "
              >
                <div class="leftInfo">
                  <div class="fontLine noExceed Bigfont">{{ menu.name }}</div>
                  <div class="fontLine noExceed Subname">
                    {{ menu.name_en }}
                  </div>
                  <div
                    class="fontLine noExceed Subname"
                    v-if="menu.introduction"
                  >
                    {{ menu.introduction }}
                  </div>
                  <div style="height: 5px;"></div>
                  <div class="dishItem_footer">
                    <!-- 价格 -->
                    <div class="fontLine noExceed price_num">
                      <div
                        v-if="
                          menu.original_price || menu.special_price !== null
                        "
                      >
                        <span class="currentPrice">
                          <span class="priceIcon">
                            {{ sessionStorage.getItem("currency") }}
                          </span>
                          {{
                            menu.type == "o"
                              ? menu.original_price
                              : menu.special_price
                          }}
                        </span>
                        &nbsp;
                        <span class="oldPrice" v-show="menu.type == 's'">
                          <span class="priceIcon currentPrice">
                            {{ sessionStorage.getItem("currency") }}
                          </span>
                          {{ menu.original_price }}
                        </span>
                      </div>
                      <div v-else>
                        <span class="priceIcon currentPrice">
                          {{ sessionStorage.getItem("currency") }}
                        </span>
                        0
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- 没产品 -->
          <template v-else>
            <div style="text-align: center; line-height: 80px;">
              {{ $t("Dishes.nonefood") }}
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      level: 5,
      activeKey: 0,
      isShopCartShow: false,
      dishes: [],
      actMenus: [],
      shopCart: {},
      packages: {},
      count: 4,
      isAll: false,
      timer: null
    };
  },
  mounted: function() {
    this.getDishes();
    this.shopInfos = JSON.parse(sessionStorage.shopInfos);
    this.timer = setInterval(() => {
      this.$nextTick(() => {
        this.$el.style.setProperty(
          "--background-color",
          sessionStorage.colorCode
        );
        const stepper = this.$refs.input[0];
        const plusButton = stepper.$el.querySelector(".van-stepper__plus");
        if (plusButton) {
          const style = window.getComputedStyle(plusButton);
          const backgroundColor = style.backgroundColor;
          console.log("Background color:", backgroundColor);
          if (backgroundColor != "rgb(85, 85, 85)") {
            this.timer = clearInterval(this.timer);
            this.timer = null;
            console.log(this.timer);
          }
        } else {
          console.log("Element with class .van-stepper__plus not found");
        }
      });
    }, 1000);
  },
  methods: {
    getDishes() {
      // 获取
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build +
          "/api/store/" +
          sessionStorage.storeId +
          "/customerMenus/in"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.dishes = res.data.data;
            // this.getPackages();
            this.actMenus = this.dishes[this.activeKey].menus;
            this.isAll = true;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    getPackages() {
      // 获取
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build +
          "/api/store/" +
          sessionStorage.storeId +
          "/customerPackages/in"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.packages = res.data.data;
            var packages = {};
            packages.name = this.$t("Dishes.package");
            packages.menus = res.data.data;
            this.dishes = this.prepend(this.dishes, packages);
            this.actMenus = this.dishes[this.activeKey].menus;
            this.isAll = true;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    changeKey() {
      sessionStorage.setItem("activeKey", this.activeKey);
      this.actMenus = this.dishes[this.activeKey].menus;
      console.log(this.actMenus);
      setTimeout(() => {
        this.$refs.input.forEach(d => {
          d.$refs.input.nextElementSibling.style.background =
            sessionStorage.colorCode;
        });
      }, 500);
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar {
  z-index: 999;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-sidebar {
  width: 25%;
  height: calc(100% - 3.125rem);
  padding-bottom: 3.125rem;
  background-color: #bbbbbb;
  float: left;
  overflow: auto;
}
/deep/ .van-sidebar-item {
  text-align: center;
  padding: 10px 10px 10px 8px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  margin: 15px 10px 15px 0px;
  border-radius: 0px 50px 50px 0px;
}
/deep/.van-sidebar-item--select::before {
  background: none;
}
/deep/ .van-sidebar-item--select {
  color: #fff;
  border-color: #000;
  background-color: #000;
}
/deep/ .van-stepper__minus--disabled,
.van-stepper__plus--disabled {
  background-color: #bbbbbb;
  border-radius: 7px;
}
/deep/ .van-stepper__input {
  background: none;
}
/deep/ .van-stepper__plus {
  border-radius: 7px;
}
/deep/ .van-stepper__minus::before {
  color: #fff;
  height: 2px;
}
/deep/ .van-stepper__plus::before {
  color: #fff;
  height: 2px;
}
/deep/ .van-stepper__plus::after {
  color: #fff;
  width: 2px;
}
/deep/ .van-stepper__minus {
  background-color: #bbbbbb;
  border-radius: 7px;
}
/deep/ .van-divider {
  border-width: 2px;
}
/deep/ .van-stepper__plus {
  background-color: var(--background-color, #555);
}
.Bigfont {
  width: 80%;
  font-size: 17px;
  font-weight: 600;
}
.Subname {
  width: 80%;
  font-size: 12px;
  color: #bbbbbb;
  margin-top: 2px;
}
.van-button__text {
  color: #fff;
}
.contentWrapper {
  padding-top: 117px;
}
.home {
  width: 100%;
  background-color: #f3f3f3;
}
.shopTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 56px 15px 10px;
  background-color: #fff;
  position: fixed;
  width: calc(100% - 30px);
  z-index: 99;
}
.shopTitle span {
  margin-left: 10px;
  font-size: 18px;
  font-weight: 600;
}
.menuContent {
  width: 100%;
  height: calc(100vh - 120px);
  flex: auto;
  background-color: #bbbbbb;
}
.menuContent1 {
  width: 100%;
  height: calc(100vh - 120px);
  flex: auto;
  margin-bottom: 100px;
}
.dishContent {
  width: 75%;
  height: calc(100% - 3.125rem);
  padding-bottom: 3.125rem;
  float: right;
  overflow: hidden;
  overflow-y: auto;
  margin-top: 2px;
  background-color: #fff;
}
.dishItem {
  width: calc(100% - 16px);
  margin: 10px 20px;
  height: 100px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  display: flex;
  overflow: hidden;
}
.noflex {
  width: 70px;
  height: 70px;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
}
.dishItem_footer {
  display: flex;
  align-items: end;
}
.itemInfo {
  flex: auto;
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: column;
  width: 100px;
}
.leftInfo {
  margin-left: 10px;
  width: 100%;
  height: 80px;
  font-size: 14px;
}
.fontLine {
  overflow: hidden;
  word-break: break-all;
}
.price_num {
  width: 100%;
}
.icons {
  display: flex;
  width: 100%;
}
.itemIcon {
  text-align: right;
}
.enterIcon {
  position: absolute;
  top: 10px;
  right: 10px;
}
.flexBox {
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.flexNone {
  flex: none;
}
.currentPrice {
  color: #fc1617;
  font-size: 18px;
  font-weight: 600;
}
.oldPrice {
  color: #bcbcbc;
  text-decoration: line-through;
}
.cart_left {
  width: 60%;
  height: 34px;
  line-height: 34px;
  float: left;
}
.cart_right {
  width: 40%;
  height: 34px;
  line-height: 34px;
  float: right;
  text-align: right;
}
.cart_right_btn {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  color: #222;
}
.total_price {
  width: 120px;
  height: 34px;
  line-height: 34px;
  text-indent: 10px;
  font-size: 16px;
}
.cartDetail {
  width: 100%;
  height: auto;
}
.cartItem {
  width: 90%;
  margin-left: 5%;
  position: relative;
}
.leftdot {
  position: absolute;
  width: 6px;
  height: 6px;
  left: -3.5%;
  top: 15px;
  background: linear-gradient(to right, #ffc914, #ffc813);
  border-radius: 50%;
}
.cart_dish {
  width: 100%;
}
.cart_dish_name {
  width: 80%;
  height: 50px;
  line-height: 50px;
  text-indent: 5px;
}
.cart_dish_icon {
  width: 80%;
  height: 40px;
  line-height: 40px;
}
.cart_dish_price {
  width: 20%;
  height: 35px;
  line-height: 35px;
  text-align: right;
  color: #aaa;
}
.cart_dish_des {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #ccc;
}
.son_dish > .cart_dish_name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_des {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
.icon_group {
  padding-top: 10px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  clear: both;
}
.realPrice {
  color: #000;
}
.detailBar {
  width: 100%;
  height: 35px;
  line-height: 35px;
  text-align: center;
  color: #222;
  background-color: #ffc914;
  border-bottom: 1px solid #f3f3f3;
  position: relative;
}
.rightIcon {
  position: absolute;
  right: 5px;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/e_menu/Dishes.vue